export default "__VITE_ASSET__05ecc8ed__"